import React from 'react';
import PropTypes from 'prop-types';
import css from './Tile.module.css';

const Tile = ({ 
  variant = 'portrait', 
  className = '', 
  image = '/img/rectangle-4-10.svg',
  title = 'REYES pro fight gloves',
  category = 'Boxing',
  price = '£90.00',
  articleTitle = 'Training at Multiple Martial Arts Gyms',
  onClick,
}) => {
  return (
    <div className={`${css.tile} ${css[variant]} ${className}`} onClick={onClick}>
      <img
        className={css.image}
        alt={variant === 'landscape' ? articleTitle : title}
        src={image}
      />

      <div className={css.content}>
        {variant === 'landscape' ? (
          <div className={css.articleTitle}>
            <p className={css.articleText}>{articleTitle}</p>
          </div>
        ) : (
          <>
            <div className={css.title}>{title}</div>
            <div className={css.category}>{category}</div>
            <div className={css.price}>{price}</div>
          </>
        )}
      </div>
    </div>
  );
};

Tile.propTypes = {
  variant: PropTypes.oneOf(['landscape', 'portrait']),
  className: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  category: PropTypes.string,
  price: PropTypes.string,
  articleTitle: PropTypes.string,
  onClick: PropTypes.func,
};

export default Tile;

